import { registerSettingsSection } from '@/core/settings/export';
import { DataDownload } from '@/modules/calendar/export';

registerSettingsSection({
  tab: 'calendar',
  id: 'calendar-data-download',
  title: 'Calendar Data Download',
  Component: DataDownload,
});
